import { t } from 'react-switch-lang';
import styles from '../styles/ProgressBar.module.scss';
import { usePaymentProcessContext } from '../context/PaymentProcessContext';
import { STEP } from '../utils/Constants';

function StepItem({ text, active }) {
  return (
    <li aria-current={active ? 'step' : undefined}>{text}</li>
  );
}

export default function ProgressBar() {
  const { paymentProcess: { step } } = usePaymentProcessContext();

  return (
    <ul className={`${styles.ProgressBarContainer} my-3`}>
      <StepItem text={t('ProgressBarStep1')} active={step === STEP.CHOOSE_PARTNER} />
      <StepItem text={t('ProgressBarStep2')} active={step === STEP.DETAILS} />
      <StepItem text={t('ProgressBarStep3')} active={step === STEP.PAYMENT_OPTION} />
      <StepItem text={t('ProgressBarStep4')} active={step === STEP.REVIEW} />
      <StepItem text={t('ProgressBarStep5')} active={step === STEP.MAKE_PAYMENT} />
      <StepItem text={t('ProgressBarStep6')} active={step === STEP.CONFIRMATION} />
    </ul>
  );
}
